import axios from "axios";
import { getHeaders } from "../utils/helpers/main";
import endpoints from "./endpoints";

export const getAudiogramApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.audiogramFetch,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getAudiogramStatusCountApi = async params => {
    const callResponse = await axios({
      url: endpoints.audiogramCount,
      method: "get",
      headers: getHeaders(),
      params,
    })
      .then(response => response.data)
      .catch(err => err.response.data);
  
    return callResponse;
  };
  


